import {
  useTranslation,
  UseTranslationOptions,
  UseTranslationResponse,
} from 'react-i18next';
import { KeyPrefix, Namespace } from 'i18next';

/*
Allows to specify the initial path of all translations returned by the function.
E.g. useScopedTranslation('hl7.mapping'). All translations will start with 'hl7.mapping.*'
 */
export function useScopedTranslation<
  N extends Namespace,
  TKPrefix extends KeyPrefix<N> = undefined,
>(
  path: TKPrefix,
  ns?: N | Readonly<N>,
  options?: UseTranslationOptions<TKPrefix>,
): UseTranslationResponse<N, TKPrefix> {
  const i18n = useTranslation(ns, {
    ...options,
    keyPrefix: path,
  });
  return i18n;
}

export type LocalizationKey = Parameters<
  UseTranslationResponse<'translation', undefined>['t']
>[0];
export const NS_DataBlockFields = 'data-block-fields';
